import api from '../services/api';
import { clearUserCache } from '../services/auth';

export const login = async (credentials) => {
  try {
    const response = await api.post('/auth/login', credentials);
    localStorage.setItem('token', response.data.token);
    return true;
  } catch (error) {
    console.error('Erreur de connexion:', error);
    return false;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  // Vider le cache utilisateur pour éviter la persistance des données d'un autre utilisateur
  clearUserCache();
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};